<template>
    <button class="btn btn-cta-secondary" @click="$emit('click')">
        <span class="button-mask btn btn-cta-secondary"><img
                src="@/assets/icons/message.svg" alt="Message"></span>
    </button>
</template>

<script>
    export default {
        name: "ContactUsButtonCompact"
    }
</script>

<style scoped lang="scss">
    @import './src/assets/styles/variables/variables';

    button {
        position: fixed;
        bottom: 50px;
        right: 50px;
        width: 64px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 500;
        padding: 0;

        &:hover {
            .button-mask {
                background: $btn-secondary-background-hover;
            }
        }

        &:active {
            .button-mask {
                background: $btn-secondary-background-active;
            }
        }

        .button-mask {
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 42px;
            height: 42px;
        }
    }

    @media all and (max-width: 800px) {
        button {
            bottom: 70px;
            right: 6%;
        }
    }
</style>
